﻿export const isMilestoneExpanded = (milestone, topOnly, showOrHideChildren) =>
  topOnly && !showOrHideChildren.includes(milestone);
